module.exports = __webpack_public_path__ + "img/502.8979dc8c.svg";